import { render } from "./ManageAds.vue?vue&type=template&id=2add834a"
import script from "./ManageAds.vue?vue&type=script&lang=js"
export * from "./ManageAds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__